import {
  ValidationComposite,
  ValidationBuilder as Builder,
} from "../../../../validation/validators";

export const makeForgotPasswordValidation = (): ValidationComposite =>
  ValidationComposite.build([
    ...Builder.field("email").required().email().build(),
  ]);
